import { render, staticRenderFns } from "./manbingguanli-list.vue?vue&type=template&id=65186d5a&scoped=true&"
import script from "./manbingguanli-list.vue?vue&type=script&lang=ts&"
export * from "./manbingguanli-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65186d5a",
  null
  
)

export default component.exports